export function loadOneSignal() {
  if (window.OneSignal) return; // already loaded

  const script = document.createElement('script');
  script.src = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';
  script.defer = true;

  script.onload = () => {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function (OneSignal) {
      await OneSignal.init({
        appId: 'a11c8518-3d19-44b8-8b87-87ff1261a584',
      });
    });
  };

  document.body.appendChild(script);
}
